import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "companyNameInput",
    "autonomousCheckbox",
    "endDateInput",
    "currentRoleCheckbox",
    "roleInput",
    "startDateInput",
  ];

  connect() {
    document.addEventListener("cocoon:before-remove", this.beforeRemove);

    this.toggleCompanyName();
    this.toggleEndDate();
    this.validateAll();
  }

  disconnect() {
    document.removeEventListener("cocoon:before-remove", this.beforeRemove);
  }

  // ---------------------------------------------------------------------------
  // QUANDO O USUÁRIO REMOVE UMA POSITION
  // ---------------------------------------------------------------------------
  beforeRemove = (e) => {
    const block = e.detail[0];

    block.querySelectorAll("input, select, textarea").forEach((el) => {
      el.removeAttribute("required");
      el.classList.remove("is-invalid");
      if (el.name && /\[(id|_destroy)\]$/.test(el.name)) return;
      el.disabled = true;
    });
  };

  // ---------------------------------------------------------------------------
  // MARCAR PARA DESTRUIÇÃO MANUALMENTE
  // ---------------------------------------------------------------------------
  markForDestroy(event) {
    event.preventDefault();

    const wrapper = event.target.closest(".nested-fields");

    // seta _destroy = 1
    const destroyField = wrapper.querySelector("input[name*='[_destroy]']");
    if (destroyField) destroyField.value = "1";

    // remove required
    wrapper.querySelectorAll("[required]").forEach((input) => {
      input.removeAttribute("required");
    });

    // remove classes de erro
    wrapper.querySelectorAll(".is-invalid").forEach((el) => {
      el.classList.remove("is-invalid");
    });

    // Opção A: Esmaecer o bloco e desabilitar os inputs (preservando id e _destroy para envio no form)
    wrapper.style.opacity = "0.5";
    wrapper.style.pointerEvents = "none";
    wrapper.querySelectorAll("input, select, textarea").forEach((el) => {
      if (el.name && /\[(id|_destroy)\]$/.test(el.name)) return;
      el.disabled = true;
    });

    // Alterar o botão de remoção para estado de processamento
    const removeBtn = event.target.closest("a");
    if (removeBtn) {
      removeBtn.innerHTML = "Removendo... <div class='spinner-border spinner-border-sm text-danger' role='status'></div>";
      removeBtn.style.pointerEvents = "none";
    }
  }

  // ---------------------------------------------------------------------------
  // TOGGLES
  // ---------------------------------------------------------------------------
  toggleCompanyName() {
    if (this.autonomousCheckboxTarget.checked) {
      this.companyNameInputTarget.disabled = true;
      this.companyNameInputTarget.value = "";
      this.companyNameInputTarget.removeAttribute("required");
    } else {
      this.companyNameInputTarget.disabled = false;
      this.companyNameInputTarget.setAttribute("required", "required");
    }
    this.validateCompanyName();
  }

  toggleEndDate() {
    const checked = this.currentRoleCheckboxTarget.checked;

    this.endDateInputTarget.disabled = checked;

    if (checked) {
      this.endDateInputTarget.value = "";
      this.endDateInputTarget.removeAttribute("required");
    } else {
      this.endDateInputTarget.setAttribute("required", "required");
    }

    this.validateDates();
  }

  // ---------------------------------------------------------------------------
  // VALIDAÇÕES
  // ---------------------------------------------------------------------------
  validateAll() {
    this.validateCompanyName();
    this.validateRole();
    this.validateDates();
  }

  validateCompanyName() {
    if (this.companyNameInputTarget.disabled) return;

    const blank = this.companyNameInputTarget.value.trim() === "";

    if (blank) {
      this.companyNameInputTarget.classList.add("is-invalid");
    } else {
      this.companyNameInputTarget.classList.remove("is-invalid");
    }
  }

  validateRole() {
    const blank = this.roleInputTarget.value.trim() === "";

    if (blank) {
      this.roleInputTarget.classList.add("is-invalid");
    } else {
      this.roleInputTarget.classList.remove("is-invalid");
    }
  }

  validateDates() {
    if (
      !this.startDateInputTarget.disabled &&
      !this.startDateInputTarget.value
    ) {
      this.startDateInputTarget.classList.add("is-invalid");
    } else {
      this.startDateInputTarget.classList.remove("is-invalid");
    }

    const current = this.currentRoleCheckboxTarget.checked;
    const endBlank = !this.endDateInputTarget.value;

    if (!current && endBlank) {
      this.endDateInputTarget.classList.add("is-invalid");
    } else {
      this.endDateInputTarget.classList.remove("is-invalid");
    }
  }
}
